import application from "stimulus_application";
import ClientsOverlayController from "./clients_overlay_controller";
import "./clients_overlay.css";

application.register("clients-overlay", ClientsOverlayController);
